export const SwrKeys = {
  PLACE_LIST: '/places',
}

class SwrKeyHistory {
  MAX_SIZE = 100
  history: string[] = []

  add(key: string) {
    if (this.history.length >= this.MAX_SIZE) {
      this.history.shift()
    }
    this.history.push(key)
  }

  find(key: string) {
    return this.history
      .slice()
      .reverse()
      .find((x) => x.includes(key))
  }

  findAmong(keys: string[]) {
    return this.history
      .slice()
      .reverse()
      .find((x) => {
        return keys.some((k) => x.includes(k))
      })
  }
}
export const swrKeyHistory = new SwrKeyHistory()
